<template>
  <div class="learingCourse">
      <backHeader back-addr="/index"></backHeader>
      
      <div style="height:10px;"></div>
      <div style="display:flex;background-color:white;margin-left:9px;margin-right:9px;margin-bottom:8px;height:44px;line-height:44px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;" v-for="tikutype in tikuTypes" @click="goTiku(tikutype.id)">
        <p style="margin-left:12px;margin-bottom:0px;flex:3;">{{ tikutype.name }}</p>
        <img :src="tikutype.imgurl" style="height:34px;width:34px;padding-top:5px;padding-right:9px;" />
      </div>
        
  </div>
</template>
<script>

import Vue from "vue";

import openUrl from "./../utils/openUrl";

import crossLine from "./../components/cross-line.vue";
import backHeader from "./../components/back-header.vue";
import commonHeader from "./../components/common-header.vue";
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import { Toast } from "mint-ui";

export default {
  name: "learingCourse",
  data() {
    return {
     
      heightSize: 160,

      tikuTypes: [
        // {
        //   name: "我的成绩",
        //   // imgurl: require("./img/tiku/chengji.png"),
        //   imgurl: require("../assets/chengji.png"),
        //   id: "1"
        // },
        {
          name: "随机练习",
          imgurl: require("./img/tiku/suiji.png"),
          id: "2"
        },
        {
          name: "专题辅导",
          imgurl: require("./img/tiku/zhuanxiang.png"),
          id: "3"
        },
        {
          name: "历年真题精解",
          imgurl: require("./img/tiku/multi.png"),
          id: "3"
        },
        {
          name: "收藏题目",
          imgurl: require("./img/tiku/shoucang.png"),
          id: "4"
        },
        {
          name: "错误题目",
          imgurl: require("./img/tiku/cuowu.png"),
          id: "5"
        }
      ],
      
      imgBaseUrl: cfg.imgBaseUrl,

    };
  },
  methods: {
   
    goTiku(id) {
      //store.dispatch("updateTab", "tiku-item");
      this.$store.commit("updateTab", "3");
      console.log("got it");
      if (id == 1) {
        this.$router.push({
          path: "/tikuScore"
        });
      } else if (id == 2) {
        this.$router.push({
          path: "/tikuRandom"
        });
      } else if (id == 3) {
        if (this.$store.state.mineStore.isLogin == false) {
          Toast({
            message: "请先登录",
            position: "bottom",
            duration: 800
          });
          return;
        }
        this.$router.push({
          path: "/tikuSpecial"
        });
      } else if (id == 4) {
        if (this.$store.state.mineStore.isLogin == false) {
          Toast({
            message: "请先登录",
            position: "bottom",
            duration: 800
          });
          return;
        }
        this.$router.push({
          path: "/tikuCollect"
        });
      } else if (id == 5) {
        if (this.$store.state.mineStore.isLogin == false) {
          Toast({
            message: "请先登录",
            position: "bottom",
            duration: 800
          });
          return;
        }
        this.$router.push({
          path: "/tikuWrong"
        });
      }
    },
    
  },
  created: function() {
    
  },
  mounted: function() {
   
  },
  components: {
    crossLine,
    commonHeader,
    backHeader
  }
};
</script>

<style lang="scss">
@import "../assets/baseScss";
.mint-navbar .mint-tab-item.is-selected {
  color: #e70202 !important;
  border-bottom: 2px solid #e70202 !important;
}

.banner {
  background-size: cover;
  width: 100%;
  min-height: 100%;
}

.learingCourse {
  .courseItem {
    .item {
      display: flex;
      padding: 15px 15px 0px;

      .ico {
        flex: 1;
        margin-right: 10px;
      }
      .info {
        flex: 2;
        position: relative;
        .tit {
          text-align: left;
          height: 40px;
          line-height: 40px;
          overflow: hidden;
        }
        .speed {
          display: flex;
          font-size: 14px;
          line-height: 30px;
          margin-top: 5px;
          width: 100%;
          a {
            flex: 2;
            color: $cl0;
            text-align: right;
            font-weight: 500;
            i:before {
              position: relative;
              top: 1px;
            }
          }
          .mt-progress {
            flex: 3;
            color: $cl9;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module-course/index-kaoyan.vue